import * as React from 'react';
import Svg, {Path} from 'react-native-svg';
import Styles from 'src/components/Styles';

function Referral() {
  return (
    <Svg width={24} height={24} viewBox="0 0 24 24" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.858 4.857a7.001 7.001 0 00-6.68 9.1l-1.909.6A9 9 0 0116.666 4.249l1.192-1.19.8.8v3.6h-3.6l-.8-.8.948-.95a6.968 6.968 0 00-3.35-.85l.002-.001zm7 7c0-.733-.111-1.438-.32-2.1l1.909-.6A9 9 0 017.05 19.466l-1.192 1.192-.8-.8v-3.6h3.6l.8.8-.949.948a7.001 7.001 0 0010.35-6.15v.001zm-8.2-3.6h.401v-1.2h1.6v1.2h.4a1.6 1.6 0 011.6 1.6v.4h-1.6v-.4h-2.4v.745l2.714.542a1.6 1.6 0 011.286 1.569v1.145a1.6 1.6 0 01-1.6 1.6h-.4v1.2h-1.6v-1.2h-.4a1.6 1.6 0 01-1.6-1.6v-.4h1.6v.4h2.4v-1.144l-2.714-.543a1.6 1.6 0 01-1.286-1.568v-.745a1.6 1.6 0 011.6-1.6z"
        fill={Styles.Colors.PayNew.black01}
      />
    </Svg>
  );
}

const ReferralIcon = React.memo(Referral);

export default ReferralIcon;
